export default __webpack_public_path__ + "static/media/profile.01da2085.png";